import { Moment } from 'moment';
import { TipoConfiguracaoAnoBase } from './tipo-configuracao-ano-base.model';
import { AnoBase } from '.';

export class ConfiguracaoAnoBase {

  id: number;
  anoBase: AnoBase;
  tipoConfiguracao: TipoConfiguracaoAnoBase;
  dataInicio: Moment;
  dataFim: Moment;
  dataAtual: Moment;


  constructor(init?: Partial<ConfiguracaoAnoBase>) {
    Object.assign(this, init);
  }

}
